<template>
  <div class="public page">
    <AppHeader config_button>{{$root.texts.section_home.title}}</AppHeader>
    <div class="public__content">
      <div class="public__text" v-html="$root.texts.section_home.text"></div>
      <div class="public__audios">
        <div class="public__audio-item" @click="goAudio(0)">
          <img :src="getPublicURL($root.texts.free_audios.media[0].image)">
          <p class="public__audio-item-title">{{$root.texts.section_home.left_media_title}}</p>
        </div>
        <div class="public__audio-item" @click="goAudio(1)">
          <img :src="getPublicURL($root.texts.free_audios.media[1].image)">
          <p class="public__audio-item-title">{{$root.texts.section_home.right_media_title}}</p>
        </div>
      </div>
    </div>
    <router-link
      :to="{name: 'activate', params: {showBackButton: true}}"
      tag="button"
      class="btn-bottom btn-golden"
    >{{$root.texts.section_home.button}}</router-link>
  </div>
</template>

<script>
// @ is an alias to /src
import AppHeader from "@/components/AppHeader.vue";

export default {
  name: "public",
  data() {
    return {
      requesturi: "./"
    };
  },
  methods: {
    getPublicURL: function(url) {
      return this.requesturi + url;
    },
    goAudio: function(n) {
      this.$router.push("./public_player?num_audio=" + n);
    }
  },
  components: {
    AppHeader
  }
};
</script>